import Theme from '../assets/Theme';
import Logo from '../assets/images/logo.png';

export const settings = {
    theme: Theme,
    logo: Logo,
    appname: 'Reelo',
};